import './AiBanner.css';
import '../PromoBanner.css';

import React from 'react';
import { IconAi } from '@sparkol/videoscribe-react-ui';

import { ChangeStepTrigger } from 'js/actionCreators/aiFeaturesActions';

import useOpenImageGeneration from '../hooks/useOpenImageGeneration';

interface AiBannerProps {
  searchQuery?: string;
  searchResultCount?: number;
  compact?: boolean;
}

const AiBanner: React.FC<AiBannerProps> = ({ searchQuery, searchResultCount, compact = false }) => {
  const openImageGeneration = useOpenImageGeneration();

  const handleGenerate = () => {
    openImageGeneration(ChangeStepTrigger.IMAGE_LIBRARY, searchQuery);
  };

  const FEW_RESULTS_THRESHOLD = 5;
  const hasFewResults = searchResultCount !== undefined && searchResultCount < FEW_RESULTS_THRESHOLD;

  // calculate description without nested ternary
  let description = '';
  if (searchQuery) {
    description = hasFewResults ? 'Few matches? Generate it.' : 'Generate it with AI.';
  } else {
    description = "Can't find it? Describe it.";
  }

  if (compact) {
    return (
      <button
        className="PromoBanner PromoBanner--ai"
        type="button"
        aria-label="Generate with AI"
        onClick={handleGenerate}
      >
        <span className="PromoBanner__icon" aria-hidden="true">
          <IconAi />
        </span>
        <span className="PromoBanner__label">
          {searchQuery ? `Create "${searchQuery}" ` : `Generate with AI `} <span aria-hidden="true">&rsaquo;</span>
        </span>
        <span className="PromoBanner__description">{description}</span>
      </button>
    );
  }

  return (
    <aside className="AiBanner" aria-label="AI image generation">
      <IconAi className="AiBanner__icon" aria-hidden="true" />
      <div className="AiBanner__content">
        <h2 className="AiBanner__title">
          {searchQuery ? `Create “${searchQuery}” with AI` : "Can't find it? Generate it with AI"}
        </h2>
        <p className="AiBanner__description">
          {searchQuery
            ? "Nothing quite right? Describe it and we'll draw it in the VideoScribe style."
            : 'Describe any image, drawn in the VideoScribe style.'}
        </p>
      </div>
      <button className="AiBanner__action" type="button" onClick={handleGenerate}>
        Generate <span aria-hidden="true">&rsaquo;</span>
      </button>
    </aside>
  );
};

export default AiBanner;
